<template>
    <td-dialog :title="$t(title)" :visible.sync="dialogOrgVisible" :before-close="orgDialogClose" :close-on-click-modal="false" :close-on-press-escape="false" :width="diaWidth + 'px'" append-to-body>
        <div class="dialogClass" ref="treeInfo">
            <td-tree
                :lazyloading="lazyloading"
                :height="height"
                :draggable="false"
                :isDbClick="isDbClick"
                :isClick="isClick"
                @getCheckedNodes="getCheckedNodes"
                :imgloading="true"
                :defaultProps="defaultProps"
                :params="orgTreeInfo"
                @checkChange="checkChange"
                :nodeKey="nodeKey"
                :calInternal="true"
                :isPaging="true"
                :interfaceName="interfaceName"
                ref="TdDialogTree"
                @onDbClick="onDbClickTree"
                @onClick="onDbClickTree"
                :checkStrictly="checkStrictly"
                :checkNodes="checkNodes"
                :showBox="true"
                :firstChecked="firstChecked"
            >
            </td-tree>
        </div>
        <span slot="footer">
            <td-button type="primary" size="small" :loading="loading" @click="submitForm()" :style="'fontSize:' + fontsize + 'px'">{{ $t('common.CONFIRM') }}</td-button>
            <td-button size="small" @click="orgDialogClose" :style="'fontSize:' + fontsize + 'px'">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    name: 'dialogClass',
    props: {
        title: {
            type: [String, String]
        },
        dialogOrgVisible: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        checkNodes: {
            type: Array,
            default: function() {
                return [];
            }
        },
        firstChecked: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        height: {
            type: Number,
            default: function() {
                return 400;
            }
        },
        // 是否遵循父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        width: {
            type: Number,
            default: function() {
                return 220;
            }
        }
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.$nextTick(() => {
                    const dialogSize = this.$refs.treeInfo.style;
                    dialogSize.setProperty('--font-size', newVal + 'px');
                    this.diaWidth = 290 + (Number(newVal) > 14 ? Number(newVal) + 20 : 0);
                });
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    mounted() {},
    data() {
        return {
            diaWidth: 290,
            selectedNodes: [],
            loading: false,
            systemSet: '21dsec1d-4a27-48d1-we4c5-e44fcc23110',
            orgTreeInfo: {
                rootCodes: ['BH-0001'],
                pageSize: 50,
                currentPage: 1,
                needPage: true
            },
            defaultProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            interfaceName: {
                query: '/OrgManagerController/findTree',
                search: '/OrgManagerController/find'
            },
            nodeKey: 'id'
        };
    },

    methods: {
        // 提交数据
        submitForm(formName) {
            this.loading = true;
            this.selectedNodes = this.$refs.TdDialogTree.getCheckedNodes();
            if (this.selectedNodes == null || this.selectedNodes.length == 0) {
                this.$message({ showClose: true, message: this.$t('pgError.ERROR_PLEASE_SELECT_ORG'), type: 'warning' });
                this.loading = false;
                return;
            }
            this.$emit('selected', this.selectedNodes);
            this.$emit('submit');
            this.orgDialogClose();
        },
        // 关闭窗口之前需要调用的方法
        orgDialogClose() {
            this.$emit('orgDialogClose');
        },
        onDbClickTree() {},
        getCheckedNodes() {
            this.selectedNodes = this.$refs.TdDialogTree.getCheckedNodes();
        },
        // 单选框，复选框选中状态修改触发
        checkChange(data, isCheck) {
            if (isCheck && data.id == this.systemSet) {
                let node = this.$refs.TdDialogTree.getNode(data.id);
                node.setChecked(false);
                this.$message({ showClose: true, message: this.$t('pgMessage.DEPT_ROOT_NOT_SELECT'), type: 'warning' });
            }
        }
    }
};
</script>
<style>
.dialogClass {
    --font-size: 14px;
}
.custom-tree-node .span-ellipsis {
    font-size: var(--font-size) !important;
}
.el-dialog__title {
    font-size: var(--font-size) !important;
}
.el-tree-node__content {
    height: 30px !important;
}
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
